import { Images } from 'assets/images';
import { v4 as uuid } from 'uuid';

export const settings = {
  className: 'carousel',
  centerMode: false,
  arrows: false,
  centerPadding: 0,
  width: '100%',
  slidesToShow: 1,
  speed: 300,
  touchMove: true,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1281,
      settings: {
        centerPadding: '0',
      },
    },
    {
      breakpoint: 769,
      settings: {
        centerPadding: '0',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 426,
      height: '677px',
      settings: {
        centerPadding: '0',
        slidesToShow: 1,
      },
    },
  ],
};

export const slidesConfig = [
  {
    id: uuid(),
    img: Images.plane,
    description: 'We always try to make our costumer happy ',
    hash: 'LtHn~ZM{WBW=_4RjaxR-A0WBjYWX',
  },
  {
    id: uuid(),
    img: Images.homeSection1,
    description: 'We cc always try to make our costumer happy ',
    hash: 'LUJacdO?=xeT}UIoD*WVwcxtkXR+',
  },
  {
    id: uuid(),
    img: Images.homeSection2,
    description: 'We WW always try to make our costumer happy ',
    hash: 'LJKc^V_39YwICT?at3s:_N-:s,XS',
  },
  {
    id: uuid(),
    img: Images.homeSection3,
    description: 'We CC always try to make our costumer happy ',
    hash: 'LiI#+7_3xaWB?w%LfRWWyDMxoLt7',
  },
];

export const title = 'Individual Travel Assistant Hero';
export const description =
  'Explore your world and enjoy everything we have to offer. We’re ready for this adventure! Get your holiday on!';
